import { render } from "./PercentageValue.vue?vue&type=template&id=f4f9a0be"
import script from "./PercentageValue.vue?vue&type=script&lang=js"
export * from "./PercentageValue.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__